import ExcelJS from "exceljs";
import { makeSummarySheet } from "./sheets/01-summary-sheet";
import { makeDataSheet } from "./sheets/02-data-sheet";
import { makeViewerSheets } from "./sheets/03-viewer-sheets";
/**
 * @description 엑셀 워크북 생성 함수 (data => excel workbook)
 *
 * @param data
 * @returns
 */
export function buildWorkbook(data, options) {
    const { productClassificationInfo } = options;
    const workbook = new ExcelJS.Workbook();
    makeSummarySheet(workbook, options);
    makeDataSheet(workbook, data);
    makeViewerSheets(workbook, productClassificationInfo);
    return workbook;
}
